import { informacionBasicaTypes } from "../../types/informacionBasicaTypes";
import { informacionBasicaState } from "../../states/informacionBasicaState";

export const informacionBasicaReducer = ( state = informacionBasicaState, action ) => {
    switch ( action.type ) {
		case informacionBasicaTypes.INFO_BASICA_SAVE_START:
            return { ...state, isLoading: true };

		case informacionBasicaTypes.INFO_BASICA_SAVE_COMPLETE:
            return { ...state, isLoading: false, ...action.payload };

        case informacionBasicaTypes.INFO_BASICA_SAVE_ERROR:
            return { ...state, isLoading: false, ...action.payload };

        case informacionBasicaTypes.INFO_BASICA_VALIDATED:
            return { ...state, isLoading: false, ...action.payload };

        case informacionBasicaTypes.INFO_BASICA_UPDATED:
            return { ...state, isLoading: false, ...action.payload };
        
        default:
            return { ...state };
    }
}
